// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/style/index.scss'
import store from './store'
import utils from './utils/utils'
import md5 from 'js-md5'
import 'font-awesome/css/font-awesome.css'
Vue.mixin(utils)

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$md5 = md5
Vue.prototype.$getDays = function(num) {
  var date = new Date();
  //当使用setDate()之后，date对象就发生了改变，所以之后getDate()就能获取到指定的日期
  //这里的num就是要加的天数，减也可以。
  date.setDate(date.getDate() + num)

  let year = date.getFullYear() //年
  let month = date.getMonth() + 1 //月
  let day = date.getDate(); //天数
  if (month >= 1 && month <= 9) {
    month = `0${month}`
  }
  if (day >= 1 && day <= 9) {
    day = `0${day}`
  }
  return `${year}-${month}-${day}`
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js